import $ from 'jquery'

const main = () => {
    // フェードイン
    $(window).scroll(function () {
        const windowHeight = $(window).height();
        const scroll = $(window).scrollTop();
    
        $('.animate-fadein').each(function () {
            const targetPosition = $(this).offset().top;
            if (scroll > targetPosition - windowHeight + 200) {
            $(this).addClass("action");
        }
        });
    });

    // ヘッダーロゴフェードイン
    (function() {
        const fh = document.getElementById('animate-logo-fadein');
        window.addEventListener('scroll', () => {
            if (window.matchMedia("(max-width: 600px)").matches){
                if (window.pageYOffset > 500) {
                    fh.classList.add('is-show');
                } else {
                    fh.classList.remove('is-show');
                }
            }else{
                if (window.pageYOffset > 700) {
                    fh.classList.add('is-show');
                } else {
                    fh.classList.remove('is-show');
                }
            }
        });
    }());
}

export default main